/**
 * V2 "What's what" — the five words of Yoink Adventures, as a page
 * (user request 2026-08-11: the yoink/category/place/journal/list model
 * deserves a plain glossary in Help; docs/JOURNAL-PLAN.md §2 is the
 * internal version of the same table).
 *
 * Static content, no data. The one rule of the copy: each term is
 * defined by what it IS to the reader, then one line of how it relates
 * to the others — the confusions this page exists to prevent are
 * "is the journal entry in the list?" (no — lists hold places) and
 * "are lists private categories?" (no — categories shelve visits,
 * lists shelve places).
 */

const TERMS = [
  {
    icon: '📍',
    name: 'Place',
    what: 'A real spot on the map — a restaurant, a trailhead, a lighthouse. Everyone’s yoinks and lists point at the same shared places.',
  },
  {
    icon: '📸',
    name: 'Yoink',
    what: '“I was here” — your visit to a place, with a photo and the date. Every yoink lives on your profile and its place’s page; the ones in site categories also ride the public map and feeds.',
  },
  {
    icon: '🗂️',
    name: 'Category',
    what: 'The site’s shelves for yoinks — Lighthouses, Trails, Street Corn… — curated by the rangers and shared by everyone.',
  },
  {
    icon: '🔒',
    name: 'Personal category',
    what: 'A shelf you make yourself — “My restaurants,” “Dive bars.” Yoinks filed under one show on your profile like any other, but stay off the public map, feeds and category counts.',
  },
  {
    icon: '🔖',
    name: 'List',
    what: 'Places you’re collecting — “Want to go,” “Top ten burgers” — visited or not, in your order, with your notes. Private, shareable by link, or public: your call per list.',
  },
];

export function mount(el) {
  const basePath = window.YOINK_CONFIG?.basePath || '/adventure';
  document.title = 'What’s what | Yoink Adventures v2';
  el.innerHTML = `
    <nav class="v2-back" aria-label="Back"><a href="${basePath}/" data-route="discover">← Discover</a></nav>
    <article class="v2-log glossary">
      <h2 class="log-heading">What’s what</h2>
      <p class="log-hint">Five words carry the whole app. Here’s each one, plainly.</p>
      <dl class="glossary-terms">
        ${TERMS.map((t) => `
        <div class="glossary-term">
          <dt><span aria-hidden="true">${t.icon}</span> ${t.name}</dt>
          <dd>${t.what}</dd>
        </div>`).join('')}
      </dl>
      <h3 class="help-subhead">How they fit together</h3>
      <p class="glossary-note"><strong>Categories organize visits. Lists organize places.</strong>
        A place can hold everyone’s yoinks and sit on many lists at once.</p>
    </article>`;
  return () => {};
}
